import React, { useEffect, useState } from 'react';
import Logo from './logo';
import { FaUserCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import "./components.css";
import "./home.css";
import './Out_Bound/Conditionstable.css';
import { ToastContainer } from 'react-toastify';

function Navbar() {
    const [Display_Name, setDisplay_Name] = useState('');

    useEffect(() => {
        const username = Cookies.get('name');
        setDisplay_Name(username);
    }, [])
    return (
        <>
            <div className='nav df jb ac'>
                <div className='h_logo df gap ac'>
                    <Logo />
                    <p className='w'>2XCONNECT</p>
                </div>

                <div className='h_nav w15 df ac jc gap2'>
                    <p className='w60 df je w'>{Display_Name}</p>
                    <Link to={"/"} className='user_icon df jc ac'><FaUserCircle className='icon5' /></Link>
                </div>
            </div>
            <ToastContainer />
        </>

    )
}

export default Navbar;